import $ from 'jquery';

window.addEventListener('DOMContentLoaded', () => {
  const $backToTop = $('.back-to-top');

  function checkPosition() {
    // Toggle back to top button
    if (window.pageYOffset > window.innerHeight * 3 && window.innerWidth <= 768) {
      $backToTop.fadeIn();
    } else {
      $backToTop.fadeOut();
    }
  }

  $backToTop.on('click', () => {
    $('html, body').animate({ scrollTop: 0 }, 400);
  });

  window.addEventListener('scroll', checkPosition);
});
